import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/fr/text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ade2a78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ade2a78', __exports__)) {
    api.reload('2ade2a78', __exports__)
  }
  
}


export default __exports__